import { useRouter } from "next/router";
import styled from "styled-components";
import { TApplicationData } from "@/typings/Props";
import { useTranslation } from "react-i18next";
import { theme } from "@/styles/theme";
import { media } from "@/styles/media";

export type TProps = {
  title: string;
  titleCaption?: string;
  desc?: string;
  items: TApplicationData[];
};

export default function Items(props: TProps) {
  const router = useRouter();
  const { t } = useTranslation();
  return (
    <Wrap>
      <MainTitle
        dangerouslySetInnerHTML={{ __html: t(props.title) }}
        data-aos="fade-up"
        data-aos-easing="ease-out"
        data-aos-duration="500"
      ></MainTitle>
      {Boolean(props.titleCaption) && <MainTitleCaption>{props.titleCaption}</MainTitleCaption>}
      {Boolean(props.desc) && <MainDesc dangerouslySetInnerHTML={{ __html: t(props.desc!) }}></MainDesc>}
      <ItemsWrap>
        {props.items.map((v) => (
          <ItemWrap key={v.id}>
            <ImgWrap
              style={{ cursor: Boolean(v.href) ? "pointer" : "normal" }}
              onClick={() => Boolean(v.href) && router.push(v.href as string)}
            >
              <Img src={v.iconPath} />
            </ImgWrap>
            <Title dangerouslySetInnerHTML={{ __html: v.title }}></Title>
            <Desc>{v.desc}</Desc>
          </ItemWrap>
        ))}
      </ItemsWrap>
    </Wrap>
  );
}

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1250px;
  margin: 50px auto 0 auto;
`;
const MainTitle = styled.p`
  padding: 0 50px;
  margin-bottom: 24px;
  font-family: "Lato Bold", sans-serif;
  font-size: 44px;
  line-height: 130%;
  font-weight: ${theme.fontWeights.bold};
  text-align: center;
  white-space: pre-line;
  ${media.phablet`
    text-align: center;  
  `};
`;
const MainTitleCaption = styled.p`
  margin: 10px 0 50px 0;
  font-family: "Hind", sans-serif;
  font-size: 16px;
  text-align: center;
  color: ${theme.colors.text.grayLight};
`;
const MainDesc = styled.p`
  font-family: "Hind", sans-serif;
  font-size: 28px;
  font-weight: ${theme.fontWeights.bold};
  text-align: center;
  color: ${theme.colors.text.grayDark};
`;
const ItemsWrap = styled.div`
  margin: 50px 0 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
const ItemWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;
  width: 22%;
  min-height: 350px;
  margin: 0 20px 0 20px;
  @media (max-width: 1000px) {
    margin: 0 0 50px 0;
    padding: 0 50px;
    width: 100%;
    min-height: initial;
  }
`;
const ImgWrap = styled.div`
  max-width: 115px;
`;
const Img = styled.img`
  width: 100%;
  border-radius: 50%;
  box-shadow: 2px 2px 0.5rem ${theme.colors.background.black};
  background-color: ${theme.colors.background.black};
  user-select: none;
  -webkit-user-drag: none;

  &:hover {
    box-shadow: 2px 2px 0.5rem ${theme.colors.primary};
    background-color: ${theme.colors.primary};
  }
`;
const Title = styled.p`
  margin: 15px 0 10px 0;
  line-height: 28px;
  font-family: Hind;
  font-size: 28px;
  font-weight: ${theme.fontWeights.bold};
  text-align: center;
  color: ${theme.colors.text.grayDark};
`;
const Desc = styled.p`
  line-height: 28px;
  font-family: Hind;
  font-size: 16px;
  text-align: center;
  color: ${theme.colors.text.grayLight};
   .primary {
    color: ${theme.colors.primary};
`;
